export default __webpack_public_path__ + "static/media/sb-icon.08d4bc52.svg";